import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

export const ThemeToggle: React.FC<{ style?: React.CSSProperties; className?: string }> = ({
  style,
  className = ''
}) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`theme-toggle-btn ${className}`}
      style={style}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${theme === 'dark' ? 'Light' : 'Dark'} mode`}
    >
      {theme === 'dark' ? (
        <Sun size={17} color="#fbbf24" style={{ transition: 'transform 0.3s' }} />
      ) : (
        <Moon size={17} color="#3B82F6" style={{ transition: 'transform 0.3s' }} />
      )}
    </button>
  );
};
